import { Flex } from "@chakra-ui/react";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import { CollapsibleHistory } from "features/PlatformEvents";
import MeetingForm from "features/Resources/Meeting/Layout/MeetingForm";
import PastMeeting from "features/Resources/Meeting/Layout/PastMeeting";
import { Meeting } from "features/Resources/Meeting/models";

interface MeetingDrawerFormProps {
  meeting: Meeting;
}

export default function MeetingDrawerForm({ meeting }: MeetingDrawerFormProps) {
  const { data: newHireJourney } = useNewHireJourneyDetailQuery(meeting?.newHireJourneyId);
  if (!meeting) {
    return null;
  }

  return (
    <Flex direction="column">
      {meeting && (
        ["delivered", "skipped"].includes(meeting.status) ? (
          <PastMeeting meeting={meeting} includeHeader={false} includeStatus={false} />
        ) : (
          <MeetingForm
            data={meeting}
            includeHeader={false}
            includeMenu={false}
            includeStatus={false}
            isPending={newHireJourney?.isPending ?? false}
          />
        )
      )}
      <CollapsibleHistory entityId={meeting.id} entityType="Meeting" eventType="meeting" />
    </Flex>
  );
}
